import React, { memo } from "react";

import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";

import LeadFinderButton from "./LeadFinderButton";
import OpenListButton from "./OpenListButton";
import styles from "./TopCommandsBar.module.scss";

interface Props {}

const TopCommandsBar: React.FC<Props> = () => {
  return (
    <Interactive>
      <div className={styles.container}>
        <LeadFinderButton />
        <OpenListButton />
      </div>
    </Interactive>
  );
};

export default memo(TopCommandsBar);
